<template>
  <div>
  <table class="d-table d-table__tasks">
    <thead>
    <tr>
      <th class="th-sorter"
          :class="{'th-sorter--active': sortKey === 'name'}"
          @click="setSortKey('name')">
        {{ getI18n(title) }}
        <span class="icon-menu-open"></span>
      </th>
      <th class="th-sorter"
          :class="{'th-sorter--active': sortKey === 'calendar'}"
          @click="setSortKey('calendar')">
        {{ $t('vue2.task_overview.belongs_to') }}
        <span class="icon-menu-open"></span>
      </th>
      <th class="td-dates"><template v-if="hasAnyDates">Dato</template></th>
      <th class="is-number th-sorter"
          v-if="!isOnlyShowScheduled"
          @click="setSortKey('hours')"
          :class="{'th-sorter--active': sortKey === 'hours'}">
        {{ $t('vue2.assign_users_hours.assigned') }}
        <span class="icon-menu-open"></span>
      </th>
      <th class="th-sorter is-number"
          v-if="isShowScheduled"
          @click="setSortKey('actual')"
          :class="{'th-sorter--active': sortKey === 'actual'}">
        {{ $t('vue2.assign_users_hours.scheduled') }}
        <span class="icon-menu-open"></span>
      </th>
      <th class="th-sorter is-number"
          @click="setSortKey('diff')"
          :class="{'th-sorter--active': sortKey === 'diff'}"
          v-if="isShowScheduled && !isOnlyShowScheduled">
        {{ $t('vue2.assign_users_hours.diff') }}
        <span class="icon-menu-open"></span>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr v-if="tasks.length < 1">
      <td style="width: 90%;">
        <div style="padding: 4px" class="italic">{{ $t('vue2.task_overview.no_tasks_assigned') }}</div>
      </td>
      <td></td>
      <td></td>
      <td></td>
      <td v-if="isShowScheduled"></td>
      <td v-if="isShowScheduled"></td>
    </tr>
    <tr
      v-for="task in sortedTasks"
      :key="task.id"
      :data-task-id="task.id"
      :class="{'user-tasks__row--editable': canEditTask(task)}"
      :title="canEditTask(task) ? $t('vue2.common.edit') : null"
      @click="onTaskClick(task)"
      @contextmenu="onTaskContextMenu($event, task)">
      <td>
        <div class="task-with-edit">
          <div class="subjects_subject"
               v-if="task.can_schedule === 't'"
               :style="{'background': task.color}">
            {{ task.name }}
          </div>
          <div v-else class="subjects_subject subjects_subject--not-subject">{{ task.name }}</div>
        </div>
      </td>
      <td class="td-calendars">
        {{ getCalendarNames(task) }}
      </td>
      <td class="td-dates">{{ formatDateRange(task.from_date, task.to_date) }}</td>
      <td class="is-number" v-if="!isOnlyShowScheduled"><span v-show="!getIsHideTaskHours(task)">{{ getTasksHours(task) }}</span></td>
      <td class="is-number" v-if="isShowScheduled">{{ getTaskActual(task) }}</td>
      <td class="is-number" v-if="isShowScheduled && !isOnlyShowScheduled">{{ task.diff }}</td>
    </tr>
    </tbody>
    <tfoot>
    <tr>
      <td></td>
      <td></td>
      <td></td>
      <td class="is-number" v-if="!isOnlyShowScheduled" :class="{'th-sorter--active': sortKey === 'hours'}">{{ sumOfHours }}</td>
      <td class="is-number" v-if="isShowScheduled" :class="{'th-sorter--active': sortKey === 'actual'}">{{
          sumOfActual
        }}
      </td>
      <td class="total-hours is-number" v-if="isShowScheduled && !isOnlyShowScheduled" :class="{'th-sorter--active': sortKey === 'diff'}">
        {{ sumOfDiff }}
      </td>
    </tr>
    </tfoot>
  </table>
  <div v-if="contextMenu"
       class="d-dropdown d-dropdown--show user-tasks__context-menu text-dark"
       :style="{top: contextMenu.y + 'px', left: contextMenu.x + 'px'}"
       v-on-clickaway="closeContextMenu">
    <ul>
      <li :class="{'user-tasks__context-menu__item--disabled': !!getTransferDisabledReason(contextMenu.task)}"
          :title="getTransferDisabledReason(contextMenu.task)"
          @click="onTransferScheduled(contextMenu.task)">
        <span class="icon-arrow-left4"></span>
        {{ $t('vue2.task_overview.transfer_scheduled_to_assigned') }}
        <span class="user-tasks__context-menu__values">({{ getTasksHours(contextMenu.task) || 0 }} → {{ getTaskActual(contextMenu.task) }})</span>
      </li>
      <li @click="onEditFromContextMenu(contextMenu.task)">
        <span class="icon-pencil"></span>
        {{ $t('vue2.common.edit') }}
      </li>
    </ul>
  </div>
  </div>
</template>

<script>
import DDropdown from '../common/DDropdown'
import moment from 'moment'
import {mixin as clickaway} from 'vue-clickaway'

export default {
  components: {DDropdown},
  mixins: [clickaway],
  props: {
    userCalendarId: {
      default: 13
    },
    userId: {
      default: 7
    },
    title: {
      type: String,
      default: 'Øvrige opgaver'
    },
    tasks: {
      default: () => []
    },
    assignedHours: {
      default: '0.0'
    },
    isShowScheduled: {
      default: false,
      type: Boolean
    },
    isPreviewAsEmployee: {
      default: false,
      type: Boolean
    },
    schoolThresholdToHideTaskHours: {
      default: null
    },
    canEditTasks: {
      type: Boolean,
      default: false
    },
    userCalendarIdForTransfer: {
      default: null
    },
    isFullPeriodSelected: {
      type: Boolean,
      default: false
    },
    canTransferScheduled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      sortKey: 'name',
      sortOrder: 1,
      contextMenu: null
    }
  },
  computed: {
    localPoolTitle () {
      const title = this.$store.getters.localPoolTitle
      return title || this.$t('vue2.task_overview.pool')
    },
    isOnlyShowScheduled () {
      return this.title === 'absence' || this.title === 'substitute_hours'
    },
    sortedTasks () {
      let sortKey = this.sortKey
      let order = this.sortOrder
      let data = this.tasks
      if (sortKey) {
        data = data.sort((a, b) => {
          a = a[sortKey]
          b = b[sortKey]
          if (sortKey !== 'name' && sortKey !== 'calendar') {
            if (order < 0) {
              return a - b
            } else {
              return b - a
            }
          } else {
            a = a.toLowerCase()
            b = b.toLowerCase()
            return (a === b ? 0 : a > b ? 1 : -1) * order
          }
        })
      }
      return data
    },
    sumOfHours () {
      let tasksHours = [0]
      if (this.tasks.length > 0) {
        tasksHours = this.tasks.map(task => {
          return task.hours ? parseFloat(task.hours) : 0
        })
      }
      let sum = tasksHours.reduce((acc, item) => acc + item)
      return this.toFixedIfNecessary(sum, 2)
    },
    sumOfActual () {
      let tasksActual = [0]
      if (this.tasks.length > 0) {
        tasksActual = this.tasks.map(task => {
          let actual = task.actual ? task.actual : 0
          return parseFloat(actual)
        })
      }
      let sum = tasksActual.reduce((acc, item) => acc + item)
      return this.toFixedIfNecessary(sum, 2)
    },
    sumOfDiff () {
      let tasksNumbers = [0]
      if (this.tasks.length > 0) {
        tasksNumbers = this.tasks.map(task => {
          return task.diff ? parseFloat(task.diff) : 0
        })
      }
      let sum = tasksNumbers.reduce((acc, item) => acc + item)
      return this.toFixedIfNecessary(sum, 2)
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    subjectsInHash () {
      return this.$store.getters.subjectsInHash
    },
    hasAnyDates () {
      return this.tasks.some(task => task.from_date || task.to_date)
    }
  },
  methods: {
    getI18n (title) {
      switch (title) {
        case 'teaching':
          return this.$t('vue2.task_overview.teaching')
        case 'other':
          return this.$t('vue2.task_overview.tasks')
        case 'preparation':
          return this.$t('vue2.task_overview.preparation')
        case 'absence':
          return this.$t('vue2.task_overview.absence')
        case 'club':
          return this.$t('vue2.task_overview.club')
        case 'substitute_hours':
          return this.$t('vue2.task_overview.substitute_hours')
        case 'pool':
          return this.localPoolTitle
        case 'unknown':
          return this.$t('vue2.task_overview.unknown')
        case 'with_kids':
          return 'Tid med børn'
        case 'without_kids':
          return 'Tid uden børn'
        default:
          return title
      }
    },
    setSortKey (prop) {
      this.sortKey = prop
      this.sortOrder === 1 ? this.sortOrder = -1 : this.sortOrder = 1
    },
    toFixedIfNecessary (value, dp) {
      // https://stackoverflow.com/questions/32229667/have-max-2-decimal-places/32229831
      return +parseFloat(value).toFixed(dp)
    },
    getCalendarNames (task) {
      if (!task.calendars) {
        return task.calendar || ''
      }
      var calendars = task.calendars
      if (typeof calendars === 'string') {
        try {
          calendars = JSON.parse(calendars)
        } catch (e) {
          return task.calendar || ''
        }
      }
      if (!Array.isArray(calendars) || calendars.length < 1) {
        return task.calendar || ''
      }
      var klassNames = []
      for (var i = 0; i < calendars.length; i++) {
        if (calendars[i].calendar_type === 'klass') {
          klassNames.push(calendars[i].name)
        }
      }
      if (klassNames.length < 1) {
        return task.calendar || ''
      }
      if (klassNames.length <= 4) {
        return klassNames.join(', ')
      }
      return klassNames.slice(0, 4).join(', ') + ' ...'
    },
    getTaskActual (task) {
      let actual = task.actual ? task.actual * 1 : 0
      return this.toFixedIfNecessary(actual, 2)
    },
    getTasksHours (task) {
      return task.hours ? this.toFixedIfNecessary(task.hours, 2) : ''
    },
    // Skjuler kun selve tallet visuelt i preview ("Se opgaveoversigter"), så administratoren ser samme
    // skjulte timepuljer som en medarbejder. Tallet, summerne og de underliggende data ændres ikke.
    getIsHideTaskHours (task) {
      const threshold = this.schoolThresholdToHideTaskHours * 1
      if (!this.isPreviewAsEmployee || !threshold) {
        return false
      }
      const hours = task.hours * 1
      return task.subject_type === 'additional_tasks' && hours >= 0 && hours < threshold
    },
    calcDifference (task) {
      let actual = task.actual ? task.actual * 1 : 0
      let hours = task.hours ? parseFloat(task.hours) : null
      return task.hours ? this.toFixedIfNecessary(hours - actual, 2) : ''
    },
    canEditTask (task) {
      return this.canEditTasks && task && task.id && !task.substitute && this.title !== 'absence'
    },
    onTaskClick (task) {
      if (!this.canEditTask(task)) {
        return
      }
      this.setEditTask(task)
    },
    setEditTask (task) {
      this.$emit('edit', task)
    },
    canShowContextMenu (task) {
      if (!this.canTransferScheduled || !this.canEditTask(task) || !this.isShowScheduled || this.isOnlyShowScheduled) {
        return false
      }
      return task.can_schedule === true || task.can_schedule === 't'
    },
    // set_hours kræver en eksisterende subject_calendar for brugeren
    isTeacherOnTask (task) {
      const isInOwnCalendar = (task.calendar_id_for_subject * 1) === (this.userCalendarIdForTransfer * 1)
      return isInOwnCalendar || !!task.subject_calendar_id
    },
    getTransferDisabledReason (task) {
      if (!this.isFullPeriodSelected) {
        return this.$t('vue2.task_overview.transfer_scheduled_only_full_period')
      }
      const hours = task.hours ? this.toFixedIfNecessary(task.hours, 2) : 0
      if (hours === this.getTaskActual(task)) {
        return this.$t('vue2.task_overview.transfer_scheduled_already_equal')
      }
      return ''
    },
    onTaskContextMenu (event, task) {
      if (!this.canShowContextMenu(task)) {
        return
      }
      event.preventDefault()
      const x = event.clientX
      const y = event.clientY
      if (!this.isTeacherOnTask(task)) {
        this.$emit('assignTeacher', task, () => this.openContextMenu(task, x, y))
        return
      }
      this.openContextMenu(task, x, y)
    },
    openContextMenu (task, x, y) {
      this.contextMenu = {task: task, x: x, y: y}
    },
    closeContextMenu () {
      this.contextMenu = null
    },
    onTransferScheduled (task) {
      if (this.getTransferDisabledReason(task)) {
        return
      }
      this.closeContextMenu()
      this.$emit('transferScheduled', task)
    },
    onEditFromContextMenu (task) {
      this.closeContextMenu()
      this.setEditTask(task)
    },
    setDeleteTask (task) {
      this.$emit('delete', task)
    },
    getShowCalendarIfNotOwn (task) {
      let isInOwnCalendar = task.belongs_to_calendars ? task.belongs_to_calendars.indexOf(this.userCalendarId) > -1 : task.calendar_id === this.userCalendarId
      if (isInOwnCalendar) {
        return []
      } else {
        return task.belongs_to_calendars ? task.belongs_to_calendars.map(calId => this.allCalendarsInHash[calId]) : [this.allCalendarsInHash[task.calendar_id]]
      }
    },
    formatDateRange (fromDate, toDate) {
      if (!fromDate && !toDate) return ''
      const from = fromDate ? moment(fromDate) : null
      const to = toDate ? moment(toDate) : null
      if (from && !to) return from.format('DD-MM-YYYY')
      if (!from && to) return to.format('DD-MM-YYYY')
      if (from.isSame(to, 'day')) return from.format('DD-MM-YYYY')
      return from.format('DD-MM-YYYY') + ' - ' + to.format('DD-MM-YYYY')
    },
    scaleIndicator (diff) {
      let color = 'rgba(62, 207, 142, 0.4)'
      let newDiff = parseFloat(diff)
      let indicatorPercentage = parseFloat(newDiff.toFixed(0))
      if (indicatorPercentage < 10 && indicatorPercentage > 0) {
        indicatorPercentage = '0' + indicatorPercentage
      }
      if (indicatorPercentage > -10 && indicatorPercentage < 0) {
        indicatorPercentage = '0' + (indicatorPercentage * -1)
      }
      if (indicatorPercentage < -9 && indicatorPercentage < 0) {
        indicatorPercentage = indicatorPercentage * -1
      }
      if (newDiff === 0) {
        color = 'transparent'
      }
      if (newDiff < 0) {
        color = 'rgba(250, 86, 90, 0.' + indicatorPercentage + ')'
      }
      if (newDiff < -99) {
        color = 'rgba(250, 86, 90, 1)'
      }
      if (newDiff > 0) {
        color = 'rgba(62, 207, 142, 0.' + indicatorPercentage + ')'
      }
      if (newDiff > 99) {
        color = 'rgba(62, 207, 142, 1)'
      }
      return {'backgroundColor': color}
    }
  },
  watch: {
    tasks: {
      handler () {
        this.tasks.forEach((task, i) => this.$set(this.tasks[i], 'diff', this.calcDifference(task)))
      },
      immediate: true
    }
  },
  mounted () {
    this._onContextMenuKeydown = e => {
      if (e.key === 'Escape') {
        this.closeContextMenu()
      }
    }
    window.addEventListener('scroll', this.closeContextMenu, true)
    window.addEventListener('contextmenu', this.closeContextMenu, true)
    window.addEventListener('keydown', this._onContextMenuKeydown)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.closeContextMenu, true)
    window.removeEventListener('contextmenu', this.closeContextMenu, true)
    window.removeEventListener('keydown', this._onContextMenuKeydown)
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-table__tasks {
  border-collapse: collapse;
  background-color: #ffffff;
  width: 100%;
}

.d-table__tasks {
  font-size: 10px;
}

.d-table__tasks thead th:first-child,
.d-table__tasks tbody td:first-child {
  max-width: 400px;
  width: 30%
}

.d-table__tasks thead th:nth-child(2),
.d-table__tasks tbody td:nth-child(2),
.d-table__tasks.d-table > tfoot td:nth-child(2) {
  display: none;
}

@media only screen and (min-width: 500px) {
  .d-table__tasks {
    font-size: 1rem;
  }
}

.d-table__tasks thead th:nth-child(2),
.d-table__tasks tbody td:nth-child(2),
.d-table__tasks.d-table > tfoot td:nth-child(2) {
  display: table-cell;
}
.d-table > thead, .d-table > tfoot {
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  background: #f6f9fc;
}

.d-table > tfoot tr:last-child {
  font-size: 13px;
}

.d-table > thead > tr > th,
.d-table > tfoot > tr > td {
  padding: 5px;
}

.d-table > thead > tr:first-child, .d-table > tfoot > tr:first-child {
  color: #8898aa;
}

.d-table tr th, .d-table > tfoot tr td {
  padding: 4px 8px;
}

.d-table > tfoot tr td {
  color: #8898aa;
}

.d-table > tfoot tr td.th-sorter--active {
  color: var(--dark-blue);
}

.d-table tbody tr:nth-child(even) {
  background-color: #f9fafb;
}

.d-table tr th h4 {
  color: #3e4450;
}

.d-table tr td {
  padding: 0 8px;
}

.d-table tbody tr:hover {
  background: #eee !important;
}

.subjects_subject {
  position: relative;
  padding: 4px 6px;
  height: 30px;
  color: #ffffff !important;
  border-radius: 4px;
  word-break: break-all;
  background: #2c81ba;
  overflow: hidden;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
  text-align: left;
  margin: 5px 5px 5px 0px;
  min-width: auto;
  font-weight: bold;
  transition: transform 0.25s;
  animation: fadeIn;
}

.subjects_subject.subjects_subject--not-subject {
  box-shadow: none;
  background-color: transparent;
  color: var(--dark-blue) !important;
  border: 1px solid transparent;
}

.subjects_subject.subjects_subject--not-subject:hover {
  /* border: 1px solid var(--border-color); */
  border: none;
}

.is-number {
  text-align: right;
  min-width: 100px;
}

tbody tr:first-child td .subjects_subject {
  margin-top: 5px;
}

tbody tr:last-child td .subjects_subject {
  margin-bottom: 10px;
}

.italic {
  font-style: italic;
}

.td-calendars {
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 80px;
  overflow: hidden;
  font-size: 11px;
}

.td-dates {
  white-space: nowrap;
  font-size: 11px;
  color: #8898aa;
}

.d-table tbody td:nth-child(2) {
  width: 40%;
}

.d-table tbody td:nth-child(3),
.d-table tbody td:nth-child(4),
.d-table tbody td:nth-child(5) {
  width: 10%;
}

.user-tasks__row--editable {
  cursor: pointer;
}

.user-tasks__row--editable:hover {
  background-color: aliceblue;
}

.user-tasks__context-menu {
  position: fixed;
  min-width: 220px;
  margin-top: 0 !important;
}

.user-tasks__context-menu__values {
  color: #8898aa;
  margin-left: 0.25rem;
}

.d-dropdown > ul > li.user-tasks__context-menu__item--disabled {
  color: #8898aa;
  cursor: not-allowed;
}

@media print {
  .user-tasks__context-menu {
    display: none;
  }
}

.th-sorter {
  align-items: center;
  cursor: pointer;
  user-select: none;
  transition: transform 0.25s;
}

.th-sorter.th-sorter--active {
  color: var(--dark-blue);
}

.th-sorter:active {
  transform: scale(0.99);
}

@media print {
  .subjects_subject {
    background: transparent !important;
    font-weight: normal !important;
    height: auto !important;
    box-shadow: none;
    color: black !important;
    padding: 0;
    margin: 2px 2px 2px 0px;
  }
  .icon-menu-open {
    display: none;
  }
}

</style>



// WEBPACK FOOTER //
// UserTasksTable.vue?790406c4